import { render, staticRenderFns } from "./QuizGroupNameInput.vue?vue&type=template&id=2a47b462&scoped=true&"
import script from "./QuizGroupNameInput.vue?vue&type=script&lang=ts&"
export * from "./QuizGroupNameInput.vue?vue&type=script&lang=ts&"
import style0 from "./QuizGroupNameInput.vue?vue&type=style&index=0&id=2a47b462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47b462",
  null
  
)

export default component.exports